<template>

</template>
<script>
// import * as BABYLON from 'babylonjs'
import router from '@/router/index.js'
// import Environment from '@/core/Environment.js'

export default {
  name: 'go',
  data () {
    return {
    }
  },
  mounted () {
    this.go()
  },
  components: {

  },
  methods: {
    go () {
      // console.log('ejecuta go...')
      if (window.dimension !== this.$route.params.dimension) {
        window.environment.go(this.$route.params.dimension)
      }

      // Siempre después de una redirección retornar al home
      this.Inicio()
    },
    Inicio () {
      router.push({
        name: 'home'
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Go.vue